<section [ngClass]="{ collapsed: isCollapsed }" class="glassmorphism">
  <nav>
    <button type="button" [ngClass]="{ active: choice === 'table' }" class="choice" (click)="select('table')">Table</button>
    <button type="button" [ngClass]="{ active: choice === 'link' }" class="choice" (click)="select('link')">Lien</button>
    <button type="button" class="button-component" (click)="toggleisCollapsed()">
      @if (isCollapsed) {
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-left" viewBox="0 0 16 16">
          <path
            fill-rule="evenodd"
            d="M2 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H3.707l10.147 10.146a.5.5 0 0 1-.708.708L3 3.707V8.5a.5.5 0 0 1-1 0z" />
        </svg>
        <span class="outside-window">Aggrandir la fenêtre</span>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-right" viewBox="0 0 16 16">
          <path
            fill-rule="evenodd"
            d="M14 13.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h4.793L2.146 2.854a.5.5 0 1 1 .708-.708L13 12.293V7.5a.5.5 0 0 1 1 0z" />
        </svg>
        <span class="outside-window">Réduire la fenêtre</span>
      }
    </button>
  </nav>
  <article>
    @if (choice === 'table') {
      <dbm-table-form></dbm-table-form>
    } @else if (choice === 'link') {
      <dbm-link-form></dbm-link-form>
    }
  </article>
</section>
